"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxMeetingTimeSuggestionsData = void 0;
var HxTimeRange_1 = require("./HxTimeRange");
var HxLocationData_1 = require("./HxLocationData");
var HxAttendeeInMeetingAvailabilityData_1 = require("./HxAttendeeInMeetingAvailabilityData");
function deserializeHxMeetingTimeSuggestionsData(values) {
    var i = 0;
    var confidence = values[i++];
    var order = values[i++];
    var organizerAvailibility = values[i++];
    var timeSlot = HxTimeRange_1.deserializeHxTimeRange(values[i++]);
    var locationsValues = values[i++];
    var locations = new Array(locationsValues.length);
    for (var index = 0; index < locationsValues.length; index++) {
        locations[index] = HxLocationData_1.deserializeHxLocationData(locationsValues[index]);
    }
    var attendeeAvailabilityValues = values[i++];
    var attendeeAvailability = new Array(attendeeAvailabilityValues.length);
    for (var index = 0; index < attendeeAvailabilityValues.length; index++) {
        attendeeAvailability[index] = HxAttendeeInMeetingAvailabilityData_1.deserializeHxAttendeeInMeetingAvailabilityData(attendeeAvailabilityValues[index]);
    }
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { confidence: confidence, order: order, organizerAvailibility: organizerAvailibility, timeSlot: timeSlot, locations: locations, attendeeAvailability: attendeeAvailability };
}
exports.deserializeHxMeetingTimeSuggestionsData = deserializeHxMeetingTimeSuggestionsData;
